var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockfill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "10.7422 -73.9746 52.3926 75.4883",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6289 1.51367L54.248 1.51367C60.1562 1.51367 63.1348-1.51367 63.1348-7.91016L63.1348-33.6426C63.1348-39.9902 60.1562-43.0176 54.248-43.0176L19.6289-43.0176C13.7207-43.0176 10.7422-39.9902 10.7422-33.6426L10.7422-7.91016C10.7422-1.51367 13.7207 1.51367 19.6289 1.51367ZM17.3828-39.6484L24.2676-39.6484L24.2676-53.3203C24.2676-62.793 30.3711-67.4316 36.9141-67.4316C43.5059-67.4316 49.6582-62.793 49.6582-53.3203L49.6582-39.6484L56.543-39.6484L56.543-52.3438C56.543-67.2852 46.7285-73.9746 36.9141-73.9746C27.1484-73.9746 17.3828-67.2852 17.3828-52.3438Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockfill);
export default __webpack_public_path__ + "static/media/lock.fill.616becbe890eb924030f65d1d112f66a.svg";
export { ForwardRef as ReactComponent };